import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-thinking-step',
  templateUrl: './thinking-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full min-h-0 overflow-y-auto bg-gradient-to-br from-zinc-950 via-purple-950 to-primary text-white' },
})
export class QbThinkingStep {
  readonly brief = inject(QuickBriefService);

  stageState(index: number): 'done' | 'active' | 'upcoming' {
    if (index < this.brief.thinkStage()) {
      return 'done';
    }
    if (index === this.brief.thinkStage() && this.brief.thinkStage() < 5) {
      return 'active';
    }
    return 'upcoming';
  }
}
